import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { Grid } from '@mui/material';
import { Alert, Page } from 'vetrf-ui';
import { BreadcrumbType } from 'vetrf-ui/dist/components/page/Page/inner/Breadcrumbs/Breadcrumbs';
import { CheckDataLoading } from 'components/CheckDataLoading/CheckDataLoading';
import { GmpDto } from '../../../gmpRegistry/api/params';
import { gmpFormApi } from '../../api/gmpFormApi';
import { ViewForm } from './components/ViewForm/ViewForm';

type ViewRecordComponentProps = {
  title: string;
  registryLink: string;
  breadcrumbs: BreadcrumbType[];
  cardLink?: string;
};

export const ViewRecordComponent = ({
  title,
  breadcrumbs,
  registryLink,
  cardLink,
}: ViewRecordComponentProps) => {
  const { promiseInProgress } = usePromiseTracker();
  const [error, setError] = useState('');
  const [data, setData] = useState<GmpDto>();
  const { id } = useParams();

  const fetchData = async () => {
    setError('');
    await gmpFormApi
      .getCard(id!)
      .then(setData)
      .catch((e) => setError(e.response.data.message));
  };

  const updateData = async () => {
    trackPromise(fetchData());
  };

  useEffect(() => {
    updateData();
  }, []);

  return (
    <Page title={title} breadcrumbs={breadcrumbs} header={title}>
      <Grid container>
        <Grid item xs={12}>
          {error ? (
            <Alert closable messageType="danger">
              {error}
            </Alert>
          ) : (
            <CheckDataLoading condition={!promiseInProgress && !!data}>
              <ViewForm
                data={data!}
                updateData={updateData}
                cardLink={cardLink}
                registryLink={registryLink}
                id={id}
              />
            </CheckDataLoading>
          )}
        </Grid>
      </Grid>
    </Page>
  );
};

export default ViewRecordComponent;
